// Copyright (c) 2021, Elicenciamento. All rights reserved.

import { alpha } from "@mui/material/styles";
import { deepmerge } from "@mui/utils";

import base from "./base";

const elicenciamento = deepmerge(base, {
  overrides: {
    MuiAppBar: {
      colorPrimary: {
        backgroundColor: "#FFFFFF",
      },
    },
  },
  shape: {
    borderRadius: "8px",
  },
  palette: {
    primary: {
      light: "#002884",
      main: "#659DF0",
      dark: "#2763BD",
      background: alpha("#659DF0", 0.08),
      contrastText: "rgba(0, 0, 0, 0.87)",
    },
    secondary: {
      light: "#6DFFD7",
      main: "#28B152",
      dark: "#00B676",
      background: alpha("#1DE9A5", 0.08),
      contrastText: "rgba(0, 0, 0, 0.87)",
    },
    error: {
      light: "#FF999B",
      main: "#FF666D",
      dark: "#C73142",
      contrastText: "rgba(0, 0, 0, 0.87)",
    },
    warning: {
      light: "#FFDF73",
      main: "#FFAD42",
      dark: "#C77E06",
      contrastText: "rgba(0, 0, 0, 0.87)",
    },
    info: {
      light: "#64D8CB",
      main: "#26A69A",
      dark: "#00766C",
      contrastText: "rgba(0, 0, 0, 0.87)",
    },
    success: {
      light: "#80E27E",
      main: "#4CAF50",
      dark: "#087F23",
      contrastText: "rgba(0, 0, 0, 0.87)",
    },
    background: {
      default: "#FFFFFF",
      orange: "#FF6600",
      lightGrey: alpha("#1DE9A5", 0.08),
    },
    text: {
      primary: "#A0A0A0",
      secondary: "rgba(0, 0, 0, 0.54)",
      disabled: "rgba(0, 0, 0, 0.38)",
      orange: "#FF6600",
    },
    orange: "#FF6600",
    grey: {
      50: "#F5F6FA",
      100: "#F1F2F5",
      200: "#E6E7EB",
      300: "#DCDDE0",
      400: "#BFC1C7",
      500: "#98999E",
      600: "#6C6E75",
      700: "#363840",
      800: "#202229",
      900: "#131720",
      A100: "#D2D3D6",
      A200: "#A4A6AB",
      A400: "#515661",
      A700: "#1D2230",
    },
    divider: "#DCDDE0",
    action: {
      hover: "rgba(0, 0, 0, 0.08)",
      hoverOpacity: 0.08,
      disabled: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.12,
    },
  },
});

export default elicenciamento;
